import React, { useEffect, useRef, useState } from "react";

const remap = (value, fromLow, fromHigh, toLow, toHigh) => {
  return toLow + ((toHigh - toLow) * (value - fromLow)) / (fromHigh - fromLow);
};

const hasTouch = () => {
  return (
    "ontouchstart" in document.documentElement ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

const GifAnimation = ({
  gifSrc,
  className,
  children,
  noInit,
  noHover,
  toggle,
  ...props
}) => {
  // each instance gets their own random width
  const RAND_MS = remap(Math.random(), 0, 1, 500, 1000);

  const [hover, setHover] = useState(false);
  const [init, setInit] = useState(true);
  const ref = useRef();
  useEffect(() => {
    setInit(true);
    // init animations
    const t = setTimeout(() => {
      if (toggle !== undefined) {
        init && toggle && setInit(false);
      } else {
        setInit(false);
      }
    }, RAND_MS);

    return () => {
      clearTimeout(t);
      setInit(true);
    };
  }, [toggle]);

  useEffect(() => {
    let t;
    const handleMouseEnter = () => {
      setHover(true);
      t = setTimeout(() => {
        setHover(false);
      }, 500);
    };

    // hover listeners
    if (ref && ref.current && !hasTouch() && !noHover) {
      const el = ref.current;
      el.addEventListener("mouseenter", handleMouseEnter, { passive: true });
      //el.addEventListener("mouseleave", handleMouseExit, { passive: true });
    }

    return () => {
      if (ref && ref.current && !noHover) {
        const el = ref.current;
        el.removeEventListener("mouseenter", handleMouseEnter, {
          passive: true
        });
        // el.removeEventListener("mouseleave", handleMouseExit, {
        //   passive: true
        // });
        clearTimeout(t);
      }
    };
  }, [ref, noHover]);

  // const handleMouseEnter = () => {
  //   setHover(true);
  // };
  // const handleMouseExit = () => {
  //   //setHover(false);
  // };
  return (
    <div
      ref={ref}
      className={className}
      {...props}
      style={{
        backgroundImage: hover || init ? `url(${gifSrc})` : "none",
        color: hover || init ? "transparent" : "inherit",
        ...props.style
        // backgroundPositionY: 5
        // width: "fit-content"
      }}
    >
      {children}
    </div>
  );
};

export default GifAnimation;
